// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */
import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	epicLinkExists: {
		id: 'issue.views.field.parent.epic-link-exists-message.epicLinkExists',
		defaultMessage: 'Cannot use parent link when epic link is set.',
		description:
			'Field error message. Shows that a user cannot use parent link field, when epic link is set.',
	},
});
